import { rem } from 'polished';
import { Link } from 'react-router';
import styled, { css } from 'styled-components';
import IconLazy from '../_helpers/Icon/IconLazy';
import ImagePlaceholder from '../_helpers/Image/ImagePlaceholder';
import { ProductPreviewTitle } from '../_helpers/product/ProductPreview';

const ColStyles = css`
  padding: 0;
  display: flex;

  ${({ theme }) => theme.media('md')} {
    display: table-cell;
    vertical-align: middle;
    padding: ${rem(20)};
  }
`;

export const AmountCol = styled.div`
  ${ColStyles};
  text-align: center;
`;

export const CartProductListWrapperStyles = css`
  ${({ theme }) => theme.media('md')} {
    display: table;
    border-collapse: collapse;
    width: 100%;
  }
`;

export const Header = styled.div`
  display: none;
  font-size: ${rem(14)};
  font-weight: 700;
  white-space: nowrap;
  padding: ${rem(10)};
  ${({ theme }) => theme.media('md')} {
    display: table-header-group;
  }
`;

export const HeaderRow = styled.div`
  display: table-row;
  padding-left: 0;
`;

export const HeaderCol = styled.div`
  display: table-cell;
  padding: 0 ${rem(20)} ${rem(10)};
`;

export const InfoCol = styled.div`
  ${ColStyles};
  display: flex;
  flex: 1 0 100%;
  min-width: 1%;
  min-height: ${rem(70)};
  padding-right: ${rem(30)};
  overflow: hidden;
  margin-bottom: ${rem(10)};
  ${({ theme }) => theme.media('md')} {
    border-top-left-radius: ${({ theme }) => rem(theme.borderRadius.default)};
    border-bottom-left-radius: ${({ theme }) =>
      rem(theme.borderRadius.default)};
    margin-bottom: 0;
  }
`;

export const Info = styled.div`
  padding-top: ${rem(0)};

  ${({ theme }) => theme.media('md')} {
    padding-top: ${rem(10)};
    overflow: hidden;
  }
`;

export const HeaderColProduct = styled(HeaderCol)`
  width: 100%;
  padding-left: 0;
`;

export const Item = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.color.white};
  font-size: ${rem(14)};
  padding: ${rem(10)} 3% ${rem(10)} 3%;
  margin-bottom: ${rem(2)};
  position: relative;
  box-shadow: ${({ theme }) => theme.boxShadow.small};
  ${({ theme }) => theme.transition('box-shadow')};
  ${({ theme }) => theme.media('xs')} {
    justify-content: flex-end;
  }
  ${({ theme }) => theme.media('md')} {
    display: table-row;
    border-radius: ${({ theme }) => rem(theme.borderRadius.default)};
    &:hover {
      box-shadow: ${({ theme }) => theme.boxShadow.default};
    }
  }
`;

export const List = styled.div`
  ${({ theme }) => theme.media('md')} {
    display: table-row-group;
  }
`;

export const Name = styled(ProductPreviewTitle)`
  white-space: normal;
  font-weight: bold;
  font-size: ${rem(15)};

  ${({ theme }) => theme.media('md')} {
    overflow: hidden;
    white-space: nowrap;
    font-weight: normal;
    text-overflow: ellipsis;
    font-size: ${rem(14)};
  }

  &.big {
    font-weight: bold;
    font-size: ${rem(18)};
    white-space: normal;
    ${({ theme }) => theme.media('md')} {
      max-width: ${rem(350)};
    }
  }
`;

export const PreorderLabel = styled.div`
  color: ${({ theme }) => theme.color.primary};
  font-size: ${rem(14)};
`;

export const Price = styled.div`
  font-weight: normal;
`;

export const PriceCol = styled.div`
  ${ColStyles};
  text-align: right;
  white-space: nowrap;
`;

export const Thumb = styled(ImagePlaceholder)``;

export const TotalPrice = styled.div`
  font-weight: 700;
  font-size: ${rem(16)};

  ${({ theme }) => theme.media('md')} {
    font-size: ${rem(15)};
  }
`;

export const TotalPriceCol = styled.div`
  ${ColStyles};
  white-space: nowrap;
  text-align: right;
`;

export const ThumbWrapperStyles = css`
  margin-right: ${rem(15)};
  width: ${rem(70)};
  min-width: ${rem(70)};

  ${({ theme }) => theme.media('md')} {
    float: left;
    width: ${rem(60)};
    min-width: ${rem(60)};
  }
`;

export const ThumbWrapperPreview = styled.div`
  ${ThumbWrapperStyles};
  display: block;
  position: relative;
`;

export const ThumbLink = styled(Link)`
  display: block;
`;

export const PreviewButton = styled.button`
  ${({ theme }) => theme.size(16)};
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  line-height: 0;
`;

export const PreviewIcon = styled(IconLazy)`
  && {
    ${({ theme }) => theme.size(16)};
    position: static;
  }
`;

export const ProductLink = styled(Link)`
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const TotalPriceNewTitle = styled.div`
  color: ${({ theme }) => theme.color.primary};
  text-transform: uppercase;
  font-weight: 700;
`;

export const TotalPriceOld = styled.div`
  font-weight: 400;
  text-decoration: line-through;
`;

export const TotalPriceNew = styled.div`
  font-weight: 700;
`;

export const TotalPriceDiscountTitle = styled.div`
  color: ${({ theme }) => theme.color.success};
  text-transform: uppercase;
  font-weight: 700;
`;

export const EmptyRow = styled.div`
  display: none;
  ${({ theme }) => theme.media('md')} {
    display: table-row;
  }
`;

export const EmptyTd = styled.div`
  display: table-cell;
  padding: ${rem(5)};
  max-width: 1px;
`;

export const HeaderColCenter = styled(HeaderCol)`
  text-align: center;
`;

export const HeaderColRight = styled(HeaderCol)`
  text-align: right;
`;
